import {
  Component,
  effect,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core'
import { Router } from '@angular/router'
import { RouteService } from '../../services/route.service'
import { ROUTES } from '../../constants/routes'
import { TranslationService } from '../../services/translation.service'
import { LanguageService } from '../../services/language.service'
import { LanguageComponent } from './language/language.component'
import { MatExpansionModule } from '@angular/material/expansion'
import { LocationComponent } from './location/location.component'
import { ProductCsvTemplatesComponent } from './product-csv-templates/product-csv-templates.component'
import { AuthService } from '../../services/auth.service'
import { USER_ROLES } from '../../constants/auth'
import { IngredientCsvTemplatesComponent } from './ingredient-csv-templates/ingredient-csv-templates.component'
import { FprTemplatesComponent } from './fpr-templates/fpr-templates.component'
import { ProductSharingTemplatesComponent } from './product-sharing-templates/product-sharing-templates.component'

@Component({
  selector: 'app-settings',
  imports: [
    MatExpansionModule,
    LanguageComponent,
    LocationComponent,
    ProductCsvTemplatesComponent,
    IngredientCsvTemplatesComponent,
    FprTemplatesComponent,
    ProductSharingTemplatesComponent,
  ],
  templateUrl: './settings.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './settings.component.scss',
})
export class SettingsComponent {
  private routeService = inject(RouteService)
  private router = inject(Router)
  translationService = inject(TranslationService)
  private languageService = inject(LanguageService)
  private authService = inject(AuthService)

  isAdmin: boolean = false
  isComplianceOfficer: boolean = false

  constructor() {
    const routeService = this.routeService

    const currentRoute = routeService.getUserRoutes(
      ROUTES.VITE_MARKETPLACE.title,
      `${ROUTES.SETTINGS.path}`,
    )
    routeService.setRoute(currentRoute)

    effect(() => {
      this.isAdmin = this.authService.currentUserRole() === USER_ROLES.ADMIN
      this.isComplianceOfficer =
        this.authService.currentUserRole() === USER_ROLES.COMPLIANCE_OFFICER
    })
  }
}
